import {
  clearStore,
  DB_VERSION,
  getNextWords,
  getStudentProfiles,
  openDB,
  saveData,
  storeWords,
  studentLearningProgress,
  submit,
} from "./_db";
import { fetchAndParseCsv } from "./_fileToData";
import type { Submission, Word } from "./backendTypes";

const CLASS_ID = 1;

export async function getAllStudentProfiles() {
  return await getStudentProfiles(CLASS_ID);
}

export async function practiceWords(studentId: number) {
  return await getNextWords(studentId);
}

export async function checkStudentAnswer(
  submission: Submission
): Promise<boolean> {
  return await submit(submission);
}

export async function getStudentLearningProgress(studentId: number) {
  return await studentLearningProgress(studentId);
}

export async function initialSetup() {
  const lastDbVersion = Number(localStorage.getItem("dbVersion") || "0");
  if (lastDbVersion >= DB_VERSION) {
    return;
  }

  try {
    await openDB();
    console.log("Database initalized succesfully.");
  } catch (error) {
    console.error(`Failed to initialize DB: ${error}`);
  }

  const classData = [{ grade: "I", className: "A" }];

  try {
    await saveData(classData, "class");
    console.log("Saved classes to db.");
  } catch (error) {
    console.error(`Failed to save class to DB: ${error}`);
  }

  const studentData = [
    {
      studentName: "Madhu",
      classId: CLASS_ID,
      colour: "bg-blue-400",
      emoji: "/profile-icons/image-9.png",
    },
    {
      studentName: "Saila",
      classId: CLASS_ID,
      colour: "bg-pink-400",
      emoji: "/profile-icons/image-20.png",
    },
    {
      studentName: "Shreyas",
      classId: CLASS_ID,
      colour: "bg-purple-400",
      emoji: "/profile-icons/image-12.png",
    },
    {
      studentName: "Aditri",
      classId: CLASS_ID,
      colour: "bg-pink-400",
      emoji: "/profile-icons/image-11.png",
    },
    {
      studentName: "Harsh",
      classId: CLASS_ID,
      colour: "bg-blue-400",
      emoji: "/profile-icons/image-7.png",
    },
  ];

  try {
    for (const student of studentData) await saveData(student, "student");
    console.log("Saved student data.");
  } catch (error) {
    console.error(`Failed to save students to DB: ${error}`);
  }

  const first100Words =
    "https://storage.googleapis.com/vocab-images/word-lists/first_v2.csv";

  const words: Word[] = await fetchAndParseCsv(first100Words);
  console.log(words);

  try {
    await storeWords(words);
    console.log("Saved words to database.");
  } catch (error) {
    console.log(`Error while storing words: ${error}`);
  }

  const imageModelUrl = await fetch(
    "https://storage.googleapis.com/vocab-images/models/mobilenet_sketch_classifier.onnx"
  );
  const imageModelFile = await imageModelUrl.blob();
  const imageModel = {
    modelUse: "image",
    modelName: "sketch_model.onnx",
    modelFile: imageModelFile,
  };

  try {
    await saveData(imageModel, "model");
    console.log("Saved image model to DB.");
  } catch (error) {
    console.error("Failed to save image model to DB", error);
  }

  // List of files typically needed for Whisper models
  const baseUrl = "https://storage.googleapis.com/vocab-images/models";
  const requiredFiles = [
    "config.json",
    "generation_config.json",
    "preprocessor_config.json",
    "tokenizer_config.json",
    "tokenizer.json",
    "decoder_model_merged_quantized.onnx",
    "encoder_model_quantized.onnx",
  ];

  const downloadPromises = requiredFiles.map(async (fileName) => {
    try {
      const url = `${baseUrl}/${fileName}`;
      console.log(`Downloading ${fileName}...`);

      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(
          `Failed to download ${fileName}: ${response.statusText}`
        );
      }

      const blob = await response.blob();
      const audioModelFile = { modelUse: fileName, modelFile: blob };
      await saveData(audioModelFile, "model");
      console.log(`✅ Stored ${fileName} in IndexedDB`);
    } catch (error) {
      console.error(`❌ Failed to download ${fileName}:`, error);
      throw error;
    }
  });
  await Promise.all(downloadPromises);

  // Tests

  // test getNextWords

  // const nextWords = await getNextWords(1);
  // console.log(nextWords);

  // test audio english endpoint

  // const audioEngURL: Response = await fetch(
  //   "https://storage.googleapis.com/vocab-images/test-audio/microwave.wav",
  // );
  // const audioEng = await audioEngURL.blob();
  // console.log("Audio English fetched successfully:", audioEng);
  // const submission: Submission = {
  //   studentId: 1,
  //   wordEnglish: "microwave",
  //   difficulty: "E",
  //   type: "audio_english",
  //   skip: false,
  //   file: audioEng,
  //   correct: null,
  // };
  // const correct = await submit(submission);
  // console.log("Submission result:", correct);

  // test image endpoint

  // const imageURL: Response = await fetch(
  //   "https://storage.googleapis.com/vocab-images/variants/airplane/57.png",
  // );
  // const image = await imageURL.blob();
  // const submission: Submission = {
  //   studentId: 1,
  //   wordEnglish: "airplane",
  //   difficulty: "E",
  //   type: "image",
  //   skip: false,
  //   file: image,
  //   correct: null,
  // };
  // const correct = await submit(submission);
  // console.log("Submission result:", correct);

  // const nextWords = await getAllStudentProfiles();
  // console.log(nextWords);
}
